export const GET_AGGREGATED_ANALYTICS_DATA = "GET_AGGREGATED_ANALYTICS_DATA";
export const GET_AGGREGATED_ANALYTICS_SUCCESS = "GET_AGGREGATED_ANALYTICS_SUCCESS";
export const GET_AGGREGATED_ANALYTICS_FAILURE = "GET_AGGREGATED_ANALYTICS_FAILURE";
export const GET_ALL_TIME_ANALYTICS_DATA = "GET_ALL_TIME_ANALYTICS_DATA";
export const GET_ALL_TIME_ANALYTICS_SUCCESS = "GET_ALL_TIME_ANALYTICS_SUCCESS";
export const GET_ALL_TIME_ANALYTICS_FAILURE = "GET_ALL_TIME_ANALYTICS_FAILURE";
export const GET_REAL_TIME_ANALYTICS_DATA = "GET_REAL_TIME_ANALYTICS_DATA";
export const GET_REAL_TIME_ANALYTICS_SUCCESS = "GET_REAL_TIME_ANALYTICS_SUCCESS";
export const GET_REAL_TIME_ANALYTICS_FAILURE = "GET_REAL_TIME_ANALYTICS_FAILURE";
